<template>
  <div class="appendixDialog">
    <el-dialog
      title="附件"
      :visible.sync="visible"
      width="800px"
      :close-on-click-modal="false"
      class="appendix"
      :before-close="handleCloseDialog"
      :show-close="false"
      :lock-scroll="false"
    >
      <div class="main">
        <el-table :data="tableDataMaps" style="width: 100%" height="460px">
          <el-table-column prop="id" label="ID" width="120px"> </el-table-column>
          <el-table-column label="附件名称" width="310px">
            <template slot-scope="scope">
              <span class="filename" @click="handleDownLoadFn(scope.row)">{{
                scope.row.fileName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="creatorName" label="上传人" width="120px"> </el-table-column>
          <el-table-column prop="createTime" label="上传时间" width="200px"> </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleCloseDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import to from 'await-to'
import { downLoadFile } from '@/api/apply'
export default {
  data() {
    return {
      visible: false,
      tableDataMaps: [],
      object: {},
    }
  },
  methods: {
    show(row) {
      this.object = row
      if (this.object.appendixList && this.object.appendixList.length) {
        this.tableDataMaps = this.object.appendixList
      }
      this.visible = true
    },
    async handleDownLoadFn(row) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const [res, err] = await to(downLoadFile({ id: row.id }))
      if (err) return this.$message.warning(err.msg)
      loading.close()
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = row.fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleCloseDialog() {
      this.visible = false
      this.tableDataMaps = []
    },
  },
}
</script>
<style lang="scss" scoped>
.appendix {
  ::v-deep .el-dialog {
    .el-dialog__body {
      .main {
        // max-height: 500px;
        // overflow-x: hidden;
        // overflow-y: auto;
        // padding: 0;
        .is-leaf {
          background-color: #fafafa;
        }
        .el-table tbody tr {
          background-color: #fff;
        }
        .filename {
          color: #1890ff;
          cursor: pointer;
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
